import { StyledSpan } from "./IsRequired.styles";

const IsRequired = ({ isRequired }) => {
  if (!isRequired) return null;
  return <StyledSpan>*</StyledSpan>;
};

export default IsRequired;
